/* Common Imports */

import React from "react";

/* Component Imports */
import Layout from "../components/layout-components/Layout";
import Amenities from "../components/page-sections/halcyon/Amenities";
import AmenitiesMobile from "../components/page-sections/halcyon/AmenitiesMobile";
import Appreciation from "../components/page-sections/halcyon/Appreciation";
import FloorPlanSectionNew from "../components/page-sections/halcyon/FloorPlanSectionNew";
import Gallery from "../components/page-sections/halcyon/Gallery";
import MasterPlan from "../components/page-sections/halcyon/MasterPlan";
import ProjectDetails from "../components/page-sections/halcyon/ProjectDetails";
import SectionOne from "../components/page-sections/halcyon/SectionOne";
import SpaciousSection from "../components/page-sections/halcyon/SpaciousSection";
import Specifications from "../components/page-sections/halcyon/Specifications";
import ProjectDeatilsMobileCard from "../components/page-sections/halcyon/sub-components/ProjectDeatilsMobileCard";
import VirtualTour from "../components/page-sections/halcyon/VirtualTour";
import ContactUs from "../components/page-sections/index/ContactUs";

/* Session Imports */

import { withIronSessionSsr } from "iron-session/next";
import FloorPlanMobile from "../components/page-sections/halcyon/FloorPlanMobile";
import { sessionOptions } from "../lib/session";

const Halcyon = (user) => {
  const [showBottomNav, setShowBottomNav] = React.useState(false);

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      window.history.scrollRestoration = "manual";

      const handleScroll = () => {
        const scrollThreshold = 300;
        setShowBottomNav(window.scrollY > scrollThreshold);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);
  return (
    <React.Fragment>
      <Layout
        noContainer
        // hideFooter={true}
        title="Luxury BHK Apartments in HSR Layout | Halcyon by Sentient"
        description="Halcyon by sentient developers offers luxurious bhk homes in hsr layout, crafted for modern living with top-notch amenities, elegant design, and great location."
        user={user}
        showBottomNav={showBottomNav}
      >
        <SectionOne />
        <ProjectDeatilsMobileCard />
        <SpaciousSection />
        <ProjectDetails />
        <MasterPlan />
        <FloorPlanMobile />

        <VirtualTour />
        <AmenitiesMobile />
        <Amenities />
        {/* <FloorPlanSection /> */}

        <FloorPlanSectionNew />
        <Gallery />
        <Appreciation />
        <Specifications />
        <ContactUs source="Heavie Halcyon" />
      </Layout>
    </React.Fragment>
  );
};

// Halcyon.getInitialProps = async () => {
//   const liveIn = (
//     await (
//       await fetch("https://sentientdevelopers.com/api/website-config")
//     ).json()
//   )[0].liveIn;
//   return { liveIn: new Date(liveIn).toString() };
// };

export default Halcyon;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({ req, res }) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* User Authorization */
  if (user == undefined) {
    return {
      props: {
        user: { isLoggedIn: false },
      },
    };
  } else {
    /* Pass data to the page via props */
    return {
      props: { user: req.session.user },
    };
  }
}, sessionOptions);
